<template>
  <div id="cut">
    <!--工具条-->
    <el-col :span="24" class="toolbar" style="padding-bottom: 0px;">
      <el-form :inline="true" @submit.native.prevent>
        <el-form-item>
          <el-input
            id="maininput"
            placeholder="请输入刀模名称"
            prefix-icon="el-icon-search"
            v-model="name"
          ></el-input>
        </el-form-item>
        <el-form-item>
          <el-checkbox
            v-model="notScrapTime"
            style="margin-left: 20px"
            v-if="roles.indexOf('4')>-1"
          >未报废刀模</el-checkbox>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" v-on:click="doSelect" v-if="roles.indexOf('4')>-1">查询</el-button>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="show('c',null)" v-if="roles.indexOf('1')>-1">新增</el-button>
        </el-form-item>
      </el-form>
    </el-col>

    <!--工具条-->
    <el-col :span="24" class="toolbar">
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="handleCurrentChange"
        :current-page="page"
        :page-sizes="pageSizes"
        :page-size="pageSize"
        layout="total, sizes, prev, pager, next, jumper"
        :total="total"
        style="float:left;"
      ></el-pagination>
    </el-col>

    <!-- 列表 -->
    <el-table :data="infos" border style="width: 100%" v-loading="listLoading">
      <el-table-column type="expand">
        <template slot-scope="props">
          <el-form label-position="left" inline class="table-expand" @submit.native.prevent>
            <el-form-item label="角形:">
              <span>{{ props.row.angle }}</span>
            </el-form-item>
            <el-form-item label="圆孔内径:">
              <span>{{ props.row.hole }}</span>
            </el-form-item>
            <el-form-item label="虚刀/切刀:">
              <span v-if="props.row.dashed">虚刀</span>
              <span v-if="props.row.cut">切刀</span>
              <span v-if="!props.row.cut&&!props.row.dashed">无</span>
            </el-form-item>
            <el-form-item label="使用次数:">
              <span>{{ props.row.times }}</span>
            </el-form-item>
            <el-form-item label="最近使用时间:">
              <span>{{ props.row.useTime }}</span>
            </el-form-item>
            <el-form-item label="报废时间:">
              <span v-if="props.row.scrapTime">{{ props.row.scrapTime }}</span>
              <span v-else>未报废</span>
            </el-form-item>
            <el-form-item label="价格:">
              <span>{{ props.row.price }} 元</span>
            </el-form-item>
            <el-form-item label="备注:">
              <span>{{ props.row.remark }}</span>
            </el-form-item>
          </el-form>
        </template>
      </el-table-column>
      <el-table-column prop="id" label="编号"></el-table-column>
      <el-table-column prop="name" label="刀模名字"></el-table-column>
      <el-table-column prop="lbLength" label="标签长"></el-table-column>
      <el-table-column prop="lbWidth" label="标签宽"></el-table-column>
      <el-table-column prop="vSpacing" label="上下间距"></el-table-column>
      <el-table-column prop="hSpacing" label="左右间距"></el-table-column>
      <el-table-column prop="row" label="行数"></el-table-column>
      <el-table-column prop="line" label="列数"></el-table-column>
      <el-table-column prop="createTime" label="创建时间"></el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="scope">
          <template v-if="scope.row.scrapTime">
            <span>已报废</span>
          </template>
          <template v-else>
            <el-button type="text" @click="show('u',scope.row)" v-if="roles.indexOf('3')>-1">编辑</el-button>
            <el-button type="text" @click="doDelete(scope.row)" v-if="roles.indexOf('2')>-1">报废</el-button>
            <el-button type="text" @click="show('cc',scope.row)" v-if="roles.indexOf('1')>-1">复制</el-button>
          </template>
        </template>
      </el-table-column>
    </el-table>

    <!-- 弹窗界面-->
    <el-dialog
      :title="dialogFrom.title"
      :visible.sync="dialogFrom.visible"
      :close-on-click-modal="false"
      width="660px"
    >
      <el-form :model="cutter" label-width="100px" label-position="right" @submit.native.prevent>
        <el-row>
          <el-col :span="13">
            <el-form-item label="刀模名称" required>
              <el-input v-model="cutter.name" :disabled="dialogFrom.disabled"></el-input>
            </el-form-item>
          </el-col>
          <el-col :span="11">
            <el-form-item label="刀具:">
              <el-checkbox v-model="cutter.dashed">虚刀</el-checkbox>
              <el-checkbox v-model="cutter.cut">切刀</el-checkbox>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-col :span="12">
            <el-form-item label="标签长" required>
              <el-input-number
                size="small"
                v-model="cutter.lbLength"
                :precision="2"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="标签宽" required>
              <el-input-number
                size="small"
                v-model="cutter.lbWidth"
                :precision="2"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="角形R">
              <el-input-number
                size="small"
                v-model="cutter.angle"
                :precision="1"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="圆孔内径">
              <el-input-number
                size="small"
                v-model="cutter.hole"
                :precision="1"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="价格(元)" required>
              <el-input-number
                size="small"
                v-model="cutter.price"
                :precision="1"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>元</span>
            </el-form-item>
          </el-col>
          <el-col :span="12">
            <el-form-item label="上下间距" required>
              <el-input-number
                size="small"
                v-model="cutter.vSpacing"
                :precision="1"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="左右间距" required>
              <el-input-number
                size="small"
                v-model="cutter.hSpacing"
                :precision="1"
                :step="0.1"
                :min="0"
              ></el-input-number>
              <span>mm</span>
            </el-form-item>
            <el-form-item label="行数" required>
              <el-input-number size="small" v-model="cutter.row" :precision="0" :step="1" :min="0"></el-input-number>
            </el-form-item>
            <el-form-item label="列数" required>
              <el-input-number size="small" v-model="cutter.line" :precision="0" :step="1" :min="0"></el-input-number>
            </el-form-item>
          </el-col>
        </el-row>
        <el-row>
          <el-form-item label="备注" prop="remark">
            <el-input v-model="cutter.remark" type="textarea" style="width:460px"></el-input>
          </el-form-item>
        </el-row>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="init">取消</el-button>
        <el-button type="primary" @click="commit" :loading="dialogFrom.confirmLoading">提交</el-button>
      </div>
    </el-dialog>
  </div>
</template> 

<script>
export default {
  data: function() {
    return {
      postApi: {
        crud: "",
        info: {}
      },
      message: {},

      cutter: {},

      page: 1, //分页显示信息
      total: 0,
      pageSize: 10,
      infos: [],
      pageSizes: [10, 20, 30, 40],

      name: "", //查询数据
      notScrapTime: false, //不看报废

      //订单弹窗信息
      dialogFrom: {},

      listLoading: false
    };
  },
  created: function() {
    this.init();
  },
  methods: {
    init: function() {
      this.cutter = {
        name: "",
        angle: 0,
        hole: 0,
        vSpacing: 0,
        hSpacing: 0,
        row: 1,
        line: 1,
        remark: "",
        lbLength: 0,
        lbWidth: 0,
        dashed: false,
        cut: false,
        price: 0
      };
      this.dialogFrom = {
        visible: false,
        title: "",
        crud: "",
        confirmLoading: false,
        disabled: false
      };
      this.doSelect();
    },
    show: function(crud, row) {
      if (crud == "c") {
        this.dialogFrom = {
          visible: true,
          title: "添加刀模",
          crud: "c",
          confirmLoading: false,
          disabled: false
        };
      } else if (crud == "u") {
        this.dialogFrom = {
          visible: true,
          title: "修改刀模",
          crud: "u",
          confirmLoading: false,
          disabled: true
        };
        this.cutter = {
          name: row.name,
          angle: row.angle,
          hole: row.hole,
          vSpacing: row.vSpacing,
          hSpacing: row.hSpacing,
          row: row.row,
          line: row.line,
          remark: row.remark,
          lbLength: row.lbLength,
          lbWidth: row.lbWidth,
          dashed: row.dashed,
          cut: row.cut,
          price: row.price
        };
      } else if (crud == "cc") {
        this.dialogFrom = {
          visible: true,
          title: "复制刀模",
          crud: "c",
          confirmLoading: false,
          disabled: false
        };
        this.cutter = {
          name: "",
          angle: row.angle,
          hole: row.hole,
          vSpacing: row.vSpacing,
          hSpacing: row.hSpacing,
          row: row.row,
          line: row.line,
          remark: row.remark,
          lbLength: row.lbLength,
          lbWidth: row.lbWidth,
          dashed: row.dashed,
          cut: row.cut,
          price: row.price
        };
      }
    },
    //增改
    commit: async function() {
      var error = "";
      if (this.cutter.name == "") {
        error += "-刀模名字不能为空";
      }
      if (this.cutter.lbLength == 0 || this.cutter.lbWidth == 0) {
        error += "-标签长宽不能为0 ";
      }
      if (this.cutter.price == 0) {
        error += "-请输入价格 ";
      }
      if (error != "") {
        this.$message.error(error);
      } else {
        this.postApi = {
          crud: this.dialogFrom.crud,
          info: this.cutter
        };
        this.dialogFrom.confirmLoading = true;
        let message = await this.$doPost("/api/warehouse/cut", this.postApi);
        if (message.msgCode == 0) {
          if (this.dialogFrom.crud == "c") {
            this.$message({
              message: "添加成功!",
              type: "success"
            });
          }
          if (this.dialogFrom.crud == "u") {
            this.$message({
              message: "刀模" + this.cutter.name + "修改成功",
              type: "success"
            });
          }
          this.init();
        } else {
          this.$message.error(message.msg);
        }
      }
    },
    //查询
    doSelect: async function() {
      this.postApi.crud = "r";
      this.postApi.info = {
        name: this.name,
        notScrapTime: this.notScrapTime
      };
      this.listLoading = true;
      this.message = await this.$doPost("/api/warehouse/cut", this.postApi);
      if (this.message.msgCode == 0) {
        // console.log(this.message.result)
        this.total = this.message.result.infos.length;
        this.getPageInfo();
      } else {
        this.$message.error(this.message.msg);
      }
      this.listLoading = false;
    },
    //删除
    doDelete: function(row) {
      this.$confirm("将报废刀具: " + row.name, "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning"
      })
        .then(async () => {
          this.postApi.crud = "d";
          this.postApi.info = {
            name: row.name
          };
          let res = await this.$doPost("/api/warehouse/cut", this.postApi);
          if (res.msgCode === 0) {
            this.$message({
              type: "success",
              message: "报废成功"
            });
            this.name = "";
            this.doSelect();
          } else {
            this.$message.error("报废失败");
          }
        })
        .catch(() => {
          this.$message.error("放弃报废");
        });
    },
    //分页
    handleCurrentChange(val) {
      this.page = val;
      this.getPageInfo();
    },
    handleSizeChange(val) {
      this.pageSize = val;
      this.getPageInfo();
    },
    getPageInfo() {
      this.infos = [];
      for (
        let i = this.pageSize * (this.page - 1);
        i < this.pageSize * this.page;
        i++
      ) {
        if (i == this.message.result.infos.length) break;
        this.infos.push(this.message.result.infos[i]);
      }
    }
  },
  props: {
    roles: Array
  }
};
</script>

<style scoped>
.table-expand {
  font-size: 0;
}
.table-expand .el-form-item {
  margin-right: 0;
  margin-bottom: 0;
  width: 25%;
  color: #99a9bf;
}
</style>




// WEBPACK FOOTER //
// src/components/warehouse/Cut.vue